/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/noAccess/noAccess"/>
import {error} from "Core/Medius.Core.Web/Scripts/Medius/core/notification";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

export function NoAccess(): null {
    error(translate("#Core/forbiddenRequestMessageTitle"), translate("#Core/errorOccurred"));
    return null;
}
